export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 text-center">
            What Is a Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center">
            A <strong>Basetao Spreadsheet</strong> is a structured shopping research system that helps users organize products, compare sellers, track prices, manage warehouse information, and improve their buying workflow. Whether you are a beginner or an experienced international shopper, using a well-designed spreadsheet transforms chaotic browsing into an efficient, cost-saving system.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-200">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Feature</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-500">Traditional Shopping</th>
                <th className="text-left px-5 py-3.5 font-semibold text-primary-700">Basetao Spreadsheet</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/70">
              {[
                { feature: 'Product Organization', traditional: 'Manual browser tabs, easy to lose items', spreadsheet: 'Structured columns, searchable, always accessible' },
                { feature: 'Price Tracking', traditional: 'Mental notes or scattered bookmarks', spreadsheet: 'Automated calculations, multi-seller price comparison' },
                { feature: 'Seller Comparison', traditional: 'Open multiple tabs, manually compare', spreadsheet: 'Side-by-side seller ratings, prices, and shipping estimates' },
                { feature: 'Order Management', traditional: 'No centralized system, easy to forget items', spreadsheet: 'Status tracking, deadlines, consolidation planning' },
                { feature: 'Budget Control', traditional: 'Easy to overspend without tracking', spreadsheet: 'Real-time running totals, budget alerts, cost breakdown' },
                { feature: 'Research Speed', traditional: 'Hours of manual searching and comparing', spreadsheet: 'Efficient filtering, sorting, and batch processing' },
              ].map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100'}>
                  <td className="px-5 py-3 font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-3 text-foreground-500">{row.traditional}</td>
                  <td className="px-5 py-3 text-primary-700 font-medium">{row.spreadsheet}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}